import { createInertiaApp } from '@inertiajs/svelte'
import  { mount } from 'svelte';
import { setupI18n } from '$lib/i18n.js';

createInertiaApp({
  // Set default page title
  // see https://inertia-rails.dev/guide/title-and-meta
  //
  // title: title => title ? `${title} - App` : 'App',

  // Disable progress bar
  //
  // see https://inertia-rails.dev/guide/progress-indicators
  // progress: false,

  resolve: (name) => {
    const pages = import.meta.glob('../pages/**/*.svelte')
    const resolver = pages[`../pages/${name}.svelte`]
    if (!resolver) {
      console.error(`Missing Inertia page component: '${name}.svelte'`)
    }
    return resolver()
  },

  setup({ el, App, props }) {
    // Initialize i18n with translations from Rails
    const { translations, locale } = props.initialPage.props;
    setupI18n(translations || {}, locale || 'en');

    if (el) {
      mount(App, { target: el, props })
    } else {
      console.error(
        'Missing root element.\n\n' +
          'If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n' +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.',
      )
    }
  },
})
